import type { Theme } from '@fluentui/react-components'
import { webLightTheme } from '@fluentui/react-components'

/**
 * A restrained Fluent UI theme tint that maps the platform's brand tokens
 * onto the Ministerul Fericirii visual identity (deep navy + ministry green)
 * without overriding Fluent's carefully tuned neutral ramp.
 */
export const socCopilotTheme: Theme = {
  ...webLightTheme,
  colorBrandBackground: '#0b2545',
  colorBrandBackgroundHover: '#123561',
  colorBrandBackgroundPressed: '#071a33',
  colorBrandBackgroundSelected: '#123561',
  colorBrandForeground1: '#0b2545',
  colorBrandForeground2: '#123561',
  colorBrandForegroundLink: '#1f5faa',
  colorBrandForegroundLinkHover: '#174a87',
  colorCompoundBrandBackground: '#0b2545',
  colorCompoundBrandBackgroundHover: '#123561',
  colorCompoundBrandBackgroundPressed: '#071a33',
  colorCompoundBrandStroke: '#0b2545',
  colorCompoundBrandStrokeHover: '#123561',
  colorNeutralStrokeAccessible: '#0b2545',
  colorBrandStroke1: '#0b2545',
  colorBrandStroke2: '#2e7d4f',
}
